import _regeneratorRuntime from "/Volumes/VANE/marciano/studio4x4-suzuki-ecommerce/node_modules/@babel/runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Volumes/VANE/marciano/studio4x4-suzuki-ecommerce/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import { axiosInstance } from 'boot/axios.js';
import getCookies from 'boot/cookies.js';
import LocalStorage from 'quasar/src/plugins/LocalStorage.js';;
export function login(_x, _x2) {
  return _login.apply(this, arguments);
}

function _login() {
  _login = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(ctx, data) {
    var response, cookies, options;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return axiosInstance({
              url: 'auth/token',
              method: 'post',
              data: data
            });

          case 3:
            response = _context.sent;
            cookies = getCookies();
            options = {
              secure: process.env.PROD,
              expires: parseInt(response.data.tokenLife) / 60 / 1000
            };
            LocalStorage.set('auth_token', response.data.token);
            cookies.set('auth_token', response.data.token, options);
            cookies.set('auth_token_life', response.data.tokenLife, options);
            cookies.set('auth_token_type', response.data.type, options);
            options.expires = parseInt(response.data.refreshTokenLife) / 60 / 1000;
            cookies.set('refresh_token', response.data.refreshToken, options);
            cookies.set('refresh_token_life', response.data.refreshTokenLife, options);
            ctx.commit('isAuthenticated', true);
            axiosInstance.defaults.headers.common['Authorization'] = 'Bearer ' + response.data.token;
            return _context.abrupt("return", response);

          case 18:
            _context.prev = 18;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", _context.t0);

          case 21:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 18]]);
  }));
  return _login.apply(this, arguments);
}

export function logout(_x3, _x4) {
  return _logout.apply(this, arguments);
}

function _logout() {
  _logout = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(ctx, data) {
    var response, cookies;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return axiosInstance({
              url: 'auth/revoke',
              method: 'post',
              data: data
            });

          case 3:
            response = _context2.sent;
            LocalStorage.remove('auth_token');
            LocalStorage.remove('idAddress');
            LocalStorage.remove('idInvoice');
            cookies = getCookies();
            cookies.remove('auth_token');
            cookies.remove('auth_token_life');
            cookies.remove('auth_token_type');
            cookies.remove('refresh_token');
            cookies.remove('refresh_token_life');
            ctx.commit('isAuthenticated', false);
            delete axiosInstance.defaults.headers.common['Authorization'];
            ctx.commit('clean', {});
            return _context2.abrupt("return", response);

          case 19:
            _context2.prev = 19;
            _context2.t0 = _context2["catch"](0);
            return _context2.abrupt("return", _context2.t0);

          case 22:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 19]]);
  }));
  return _logout.apply(this, arguments);
}

export function clean(ctx) {
  ctx.commit('isAuthenticated', false);
  ctx.commit('clean', {});
  var cookies = getCookies();
  cookies.remove('auth_token');
  cookies.remove('auth_token_life');
  cookies.remove('auth_token_type');
  cookies.remove('refresh_token');
  cookies.remove('refresh_token_life');
}
export function register(_x5, _x6) {
  return _register.apply(this, arguments);
}

function _register() {
  _register = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3(ctx, data) {
    var response;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return axiosInstance({
              url: 'auth/register',
              method: 'post',
              data: data
            });

          case 3:
            response = _context3.sent;
            return _context3.abrupt("return", response);

          case 7:
            _context3.prev = 7;
            _context3.t0 = _context3["catch"](0);
            return _context3.abrupt("return", _context3.t0);

          case 10:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 7]]);
  }));
  return _register.apply(this, arguments);
}

export function recover(_x7, _x8) {
  return _recover.apply(this, arguments);
}

function _recover() {
  _recover = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee4(ctx, data) {
    var response;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            _context4.next = 3;
            return axiosInstance({
              url: 'auth/recover-password',
              method: 'post',
              data: data
            });

          case 3:
            response = _context4.sent;
            return _context4.abrupt("return", response);

          case 7:
            _context4.prev = 7;
            _context4.t0 = _context4["catch"](0);
            return _context4.abrupt("return", _context4.t0);

          case 10:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 7]]);
  }));
  return _recover.apply(this, arguments);
}

export function recoverPassword(_x9, _x10) {
  return _recoverPassword.apply(this, arguments);
}

function _recoverPassword() {
  _recoverPassword = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee5(ctx, data) {
    var response;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            _context5.next = 3;
            return axiosInstance({
              url: "auth/recover-password/".concat(data.token),
              method: 'PUT',
              data: {
                password: data.password
              }
            });

          case 3:
            response = _context5.sent;
            return _context5.abrupt("return", response);

          case 7:
            _context5.prev = 7;
            _context5.t0 = _context5["catch"](0);
            return _context5.abrupt("return", _context5.t0);

          case 10:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[0, 7]]);
  }));
  return _recoverPassword.apply(this, arguments);
}

export function me(_x11) {
  return _me.apply(this, arguments);
}

function _me() {
  _me = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee6(ctx) {
    var response;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            _context6.next = 3;
            return axiosInstance({
              url: 'auth/me',
              method: 'get'
            });

          case 3:
            response = _context6.sent;
            ctx.commit('me', response.data);
            return _context6.abrupt("return", response);

          case 8:
            _context6.prev = 8;
            _context6.t0 = _context6["catch"](0);
            return _context6.abrupt("return", _context6.t0);

          case 11:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[0, 8]]);
  }));
  return _me.apply(this, arguments);
}

export function updateUser(_x12) {
  return _updateUser.apply(this, arguments);
}

function _updateUser() {
  _updateUser = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee7(ctx) {
    var queryParams,
        response,
        _args7 = arguments;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            queryParams = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : {};
            _context7.prev = 1;
            _context7.next = 4;
            return axiosInstance({
              url: 'auth/me',
              data: queryParams.data,
              method: 'PUT'
            });

          case 4:
            response = _context7.sent;
            ctx.commit('me', response.data);
            return _context7.abrupt("return", response);

          case 9:
            _context7.prev = 9;
            _context7.t0 = _context7["catch"](1);
            return _context7.abrupt("return", _context7.t0);

          case 12:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, null, [[1, 9]]);
  }));
  return _updateUser.apply(this, arguments);
}

export function confirm(_x13) {
  return _confirm.apply(this, arguments);
}

function _confirm() {
  _confirm = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee8(ctx) {
    var queryParams,
        response,
        _args8 = arguments;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            queryParams = _args8.length > 1 && _args8[1] !== undefined ? _args8[1] : {};
            _context8.prev = 1;
            _context8.next = 4;
            return axiosInstance({
              url: "auth/confirm/".concat(queryParams),
              data: queryParams.data,
              method: 'GET'
            });

          case 4:
            response = _context8.sent;
            return _context8.abrupt("return", response);

          case 8:
            _context8.prev = 8;
            _context8.t0 = _context8["catch"](1);
            return _context8.abrupt("return", _context8.t0);

          case 11:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, null, [[1, 8]]);
  }));
  return _confirm.apply(this, arguments);
}

export function autologin(_x14) {
  return _autologin.apply(this, arguments);
}

function _autologin() {
  _autologin = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee9(ctx) {
    var queryParams,
        response,
        _args9 = arguments;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            queryParams = _args9.length > 1 && _args9[1] !== undefined ? _args9[1] : {};
            _context9.prev = 1;
            _context9.next = 4;
            return axiosInstance({
              url: "auth/autologin",
              data: queryParams.data,
              method: 'GET'
            });

          case 4:
            response = _context9.sent;
            return _context9.abrupt("return", response);

          case 8:
            _context9.prev = 8;
            _context9.t0 = _context9["catch"](1);
            return _context9.abrupt("return", _context9.t0);

          case 11:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9, null, [[1, 8]]);
  }));
  return _autologin.apply(this, arguments);
}

export function subcribe(_x15) {
  return _subcribe.apply(this, arguments);
}

function _subcribe() {
  _subcribe = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee10(ctx) {
    var queryParams,
        response,
        _args10 = arguments;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            queryParams = _args10.length > 1 && _args10[1] !== undefined ? _args10[1] : {};
            _context10.prev = 1;
            _context10.next = 4;
            return axiosInstance({
              url: "subscribe",
              data: queryParams.data,
              method: 'GET'
            });

          case 4:
            response = _context10.sent;
            return _context10.abrupt("return", response);

          case 8:
            _context10.prev = 8;
            _context10.t0 = _context10["catch"](1);
            return _context10.abrupt("return", _context10.t0);

          case 11:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10, null, [[1, 8]]);
  }));
  return _subcribe.apply(this, arguments);
}